import { SxProps, Theme } from '@mui/material';

export const useStyles = (theme: Theme): { [key: string]: SxProps<Theme> } => ({
  container: {
    width: '80%',
    display: 'flex',
    pt: '80px',
    pb: '40px',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      width: '100%',
      mt: '0px',
    },
  },

  divider: {
    [theme.breakpoints.down('md')]: {
      mt: 0,
    },
  },

  gridContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  leftColumn: {
    width: '50%',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      alignItems: 'center',
    },
  },

  logoFooter: {
    width: '133px',
    height: '24px',
    backgroundColor: 'primary.main',
    mb: '20px',

    [theme.breakpoints.down('md')]: {
      width: '178px',
      height: '32px',
    },
  },

  aboveIconsText: {
    mt: '40px',
    mb: '20px',
    width: '40%',

    [theme.breakpoints.down('md')]: {
      width: '60%',
      textAlign: 'center',
      mb: '40px',
    },
  },

  socialButtons: {
    mx: 0.5,

    [theme.breakpoints.down('md')]: {
      my: '50px',
    },
  },

  rightsReservedText: {
    mt: '80px',
  },

  rightColumn: {
    width: '50%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'flex-start',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      mt: '0px',
    },
  },

  legalColumn: {
    display: 'flex',
    justifyContent: 'center',
    width: '50%',
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      alignItems: 'center',
      mb: '40px',
    },
  },

  termsLink: {
    mt: '20px',
    color: 'black',
  },

  privacyLink: {
    mt: '10px',
    color: 'black',
  },

  contactColumn: {
    display: 'flex',
    justifyContent: 'center',
    width: '50%',
    flexDirection: 'column',

    [theme.breakpoints.down('md')]: {
      width: '100%',
      alignItems: 'center',
    },
  },
});
